




































import Vue from 'vue';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

export default Vue.extend({
  name: 'CropImageFormModal',
  components: {
    Cropper,
  },
  props: {
    cropper: {
      type: Boolean,
      default: true,
    },
    round: {
      type: Boolean,
      default: false,
    },
    canvaWidth: {
      type: Number,
      default: 1920,
    },
    canvaHeight: {
      type: Number,
      default: 1080,
    },
    file: {
      type: [Object, String],
    },
    confirm: null,
    updateThumbnail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    defaultSize({ imageSize, visibleArea }) {
      return {
        width: (visibleArea || imageSize).width,
        height: (visibleArea || imageSize).height,
      };
    },
    getContentType(dataURL) {
      if (
        this.src.startsWith('data:image/jpeg') ||
        this.src.includes('jpg') ||
        this.src.includes('jpeg')
      ) {
        return 'image/jpeg';
      }

      const BASE64_MARKER = ';base64,';
      const parts = dataURL.split(BASE64_MARKER);
      const contentType = parts[0].split(':')[1];
      return contentType;
    },
    toBlob(dataURL) {
      const BASE64_MARKER = ';base64,';
      const parts = dataURL.split(BASE64_MARKER);
      const contentType = parts[0].split(':')[1];
      const raw = window.atob(parts[1]);
      const rawLength = raw.length;
      const uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: contentType });
    },
    async cropImage() {
      return new Promise(resolve => {
        const result = this.$refs.cropper.getResult();
        const contentType = this.getContentType(result.canvas.toDataURL());
        console.log('contentType = ', contentType);
        const extension = contentType.split('/')[1];
        result.canvas.toBlob(blobData => {
          const file = new File([blobData], `image.${extension}`, {
            type: contentType,
            lastModified: new Date().getTime(),
          });
          resolve(file);
        }, contentType);
      });
    },
    onReady() {
      this.isLoading = false;
    },
    async onConfirm() {
      const file = await this.cropImage();
      await this.$emit('close');
      await this.confirm(file);
    },
    async onDiscard() {
      if (this.discard) {
        await this.discard();
      }
      await this.$emit('close');
    },
  },
  computed: {
    src() {
      if (typeof this.file === 'string') {
        return this.file;
      }
      if (this.updateThumbnail) {
        return this.file?.embedded_thumbnail_url || this.file?.thumbnail;
      }
      return (
        this.file?.storage_url ||
        this.file?.embedded_image_url ||
        this.file?.thumbnail
      );
    },
    cropperStencil() {
      return this.round ? 'circle-stencil' : 'rectangle-stencil';
    },
    stencilSize() {
      if (this.canvaWidth && this.canvaHeight) {
        return {
          width: this.canvaWidth,
          height: this.canvaHeight,
        };
      }
      return undefined;
    },
  },
});
